import React, { useState, useEffect, useRef, ReactElement } from 'react';

// import { IOption } from '@mail-ui/accounts-repair.select';
// import SelectMenu, { optionType } from '@mail-ui/accounts-repair.select-menu';
import { IOption } from '../Select';
import SelectMenu, { optionType } from '../SelectMenu';
import Drawer from '../Drawer';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}
export interface ISelectInputValueObj {
    selValue: IOption | null,
    iptValue: string
}
export interface ISelectInput {
    options: IOption[],
    inputId?: string,
    defaultSelValue?: IOption | null,
    defaultIptValue?: string,
    onChange: (value: ISelectInputValueObj) => any,
    errorText?: string | ReactElement,
    onBur?: (value: { iptValue: string; selValue: IOption | null; }) => any,
    onInputBur?: (value: { iptValue: string; selValue: IOption | null; }) => any,
    type?: string,
    placeholder?: string,
    optionType?: optionType,
    extraClass?: string,
    showId?: boolean,
    maxLength?: number,
    id?: string,
    useDrawer?: boolean
}

const SelectInputGroup: React.FC<ISelectInput> = ({ inputId, options, useDrawer, onChange, onBur, onInputBur, defaultSelValue, defaultIptValue, placeholder, maxLength, type, errorText, optionType, extraClass, showId, id }) => {
    const [focused, setFocused] = useState<boolean>(false);
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [selValue, setSelValue] = useState<IOption | null>(defaultSelValue || null)
    const [iptValue, setIptValue] = useState<string>(defaultIptValue || '')
    const selectRef = useRef<HTMLDivElement>(null);
    const selValueIdRef = useRef<string>('+86');

    useEffect(() => {
        const selectel = selectRef.current
        //@ts-ignore
        selectel.handleClickOutSide = (e: any) => {
            //@ts-ignore
            if(!selectel.contains(e.target) && showMenu){
                setShowMenu(false);
            }
        }
        //@ts-ignore
        document.body.addEventListener('click', selectel.handleClickOutSide)
        return () => {
            //@ts-ignore
            document.body.removeEventListener('click', selectel.handleClickOutSide);
        }
    }, [showMenu])

    useEffect(() => {
        // 选择框值改变时，触发一次onBur
        if (selValueIdRef.current !== selValue?.id) {
            onBur && onBur({
                selValue,
                iptValue
            })
            selValueIdRef.current = selValue?.id as string;
        }
    }, [onBur, selValue, iptValue])

    const handleSelChange = (option: IOption) => {
        setSelValue(option);
        onChange({
            selValue: option,
            iptValue
        })
    }
    
    const handleIptChange = (value: string) => {
        setIptValue(value);
        onChange({
            selValue,
            iptValue: value
        })
    }

    const toggleMenu = (evt: React.MouseEvent<HTMLDivElement>) => {
        setShowMenu(!showMenu)
    }

    const handleoOnBur = (value: string) => {
        setFocused(false);
        onBur && onBur({
            iptValue: value,
            selValue
        });
        onInputBur && onInputBur({
            iptValue: value,
            selValue
        })
    }

    const curValue = showId ? (selValue?.id || defaultSelValue?.id || '') : (selValue?.name || defaultSelValue?.name || '')
    const renderMenu = () =>  !useDrawer ? <SelectMenu options={options} optionType={optionType} onChange={handleSelChange} /> : <Drawer options={options} onChange={handleSelChange} optionType={optionType}  />

    return (
        <div id={id} ref={selectRef} className={`select-input-wrapper ${(focused || showMenu) ? 'input-focus' : ''} ${errorText ? 'input-error' : ''} ${optionType === 'phone' ? 'select-input-wrapper-phone' : ''} ${extraClass ? extraClass : ''}`} >
            <div className={`select-part`} onClick={toggleMenu}>
                <span className="select-value">{curValue}</span>
                <span className={`arrow ${showMenu ? 'rotate180' : ''}`}></span>
            </div>
            <div className="line"></div>
            <input onClick={() => { setShowMenu(false) }} id={inputId} value={iptValue} maxLength={maxLength} onChange={evt => handleIptChange(evt?.target?.value)} type={type || 'text'} onFocus={() => setFocused(true)} onBlur={(evt) => handleoOnBur(evt?.target?.value)} placeholder={placeholder || "资料仅用于邮箱账号的身份验证，我们不会泄漏您的个人信息"} />
            <div onClick={() => { setShowMenu(false) }} className="select-input-menu">
                {showMenu ? renderMenu() : null}
            </div>
            { errorText ? <p className="error-tip">{errorText}</p> : null}
        </div>
    )
}

export default SelectInputGroup;
